import hillo from 'hillo'
import { baseUrl } from '@/model/storage/index'

const name = 'inventoryRecord/'

export async function getClearList () {
  return (await hillo.jsonPost(baseUrl + name + 'getClearingsList', {})).data
}

export async function getClearingSummary (dateTimeFrom = null, dateTimeTo = null, operation = null) {
  return (await hillo.jsonPost(baseUrl + 'resourceLog/' + 'getSummaries', {
      dateTimeFrom,
      dateTimeTo,
      operation,
    })).data
}

export async function getResourceCount (clearingId) {
  return (await hillo.jsonPost(baseUrl + name + 'getDishResourceAmount/' + clearingId, {})).data
}

export async function getStatistic (dateTimeFrom = null, dateTimeTo = null) {
  return (await hillo.jsonPost(baseUrl + 'statistics/' + 'getDetail', {
      dateTimeFrom,
      dateTimeTo,
    })).data
}

export async function getInOutLog (dateTimeFrom = null, dateTimeTo = null) {
  return (await hillo.jsonPost(baseUrl + 'resourceLog/' + 'getDetailList', {
    dateTimeFrom,
    dateTimeTo,
  })).data
}
